import React, { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";

const KEYS = [
  ["email", "Email bildirimi"], ["sms", "SMS bildirimi"], ["push", "Push bildirimi"],
  ["news", "Haber bildirimi"], ["video", "Yeni video bildirimi"], ["live", "Canlı yayın bildirimi"],
  ["campaign", "Kampanya bildirimi"], ["announcement", "Önemli duyuru bildirimi"],
];

export default function Settings() {
  const { user, refreshUser } = useAuth();
  const [prefs, setPrefs] = useState({});
  useEffect(() => { if (user) setPrefs(user.notification_prefs || {}); }, [user?.id]);
  if (!user) return <Navigate to="/giris" replace />;

  const save = async () => {
    try { await api.put("/auth/me", { notification_prefs: prefs }); await refreshUser(); toast.success("Ayarlar kaydedildi"); } catch { toast.error("Hata"); }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-6">
      <h1 className="text-2xl md:text-3xl font-black mb-5">Ayarlarım</h1>
      <div className="bg-white border border-gray-100 rounded-lg p-5 space-y-3">
        {KEYS.map(([k, label]) => (
          <label key={k} className="flex items-center justify-between">
            <span className="text-sm">{label}</span>
            <input type="checkbox" checked={!!prefs[k]} onChange={(e) => setPrefs({ ...prefs, [k]: e.target.checked })} className="w-5 h-5 accent-[#e11d2a]" />
          </label>
        ))}
      </div>
      <button onClick={save} className="mt-4 px-4 py-2 bg-[#e11d2a] text-white rounded-md font-semibold text-sm">Ayarları Kaydet</button>
    </div>
  );
}
